<div
  class="main-page-container"
  style="background-image: url(assets/Images/tgts/tg-bg.png);"
>
  <div class="header-container">
    <img src="assets/Images/tgts/header.png" alt="" class="header-img" />
  </div>

  <div class="title-container">
    <p class="title">Select Your Preferences</p>
  </div>

  <div class="form-main-container">
    <form [formGroup]="preferencesForm" (ngSubmit)="onSubmit()">
      <!-- Interests -->
      <div>
        <div class="input-container">
          <label class="label">Interests</label>
        </div>
        <div class="select-input-container" formGroupName="interests">
          <div>
            <input
              type="checkbox"
              id="Spiritual"
              class="checkbox-input"
              formControlName="Spiritual"
            />
            <label for="Spiritual" class="checkbox-label">Spiritual</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="Heritage"
              class="checkbox-input"
              formControlName="Heritage"
            />
            <label for="Heritage" class="checkbox-label">Heritage</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="Nature"
              class="checkbox-input"
              formControlName="Nature"
            />
            <label for="Nature" class="checkbox-label">Nature</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="MedicalAndWellness"
              class="checkbox-input"
              formControlName="MedicalAndWellness"
            />
            <label for="MedicalAndWellness" class="checkbox-label"
              >Wellness</label
            >
          </div>
          <div>
            <input
              type="checkbox"
              id="Crafts"
              class="checkbox-input"
              formControlName="Crafts"
            />
            <label for="Crafts" class="checkbox-label">Crafts</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="Waterfalls"
              class="checkbox-input"
              formControlName="Waterfalls"
            />
            <label for="Waterfalls" class="checkbox-label">Waterfalls</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="Buddhist"
              class="checkbox-input"
              formControlName="Buddhist"
            />
            <label for="Buddhist" class="checkbox-label">Buddhist</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="Sports"
              class="checkbox-input"
              formControlName="Sports"
            />
            <label for="Sports" class="checkbox-label">Sports</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="Knowledge"
              class="checkbox-input"
              formControlName="Knowledge"
            />
            <label for="Knowledge" class="checkbox-label">Knowledge</label>
          </div>
        </div>
      </div>

      <!-- Accessibility -->
      <div>
        <div class="input-container">
          <label class="label">Accessibility</label>
        </div>
        <div class="select-input-container" formGroupName="accessibility">
          <div>
            <input
              type="checkbox"
              id="WheelchairFriendly"
              class="checkbox-input"
              formControlName="WheelchairFriendly"
            />
            <label for="WheelchairFriendly" class="checkbox-label"
              >Wheelchair-friendly</label
            >
          </div>
          <div>
            <input
              type="checkbox"
              id="LowWalking"
              class="checkbox-input"
              formControlName="LowWalking"
            />
            <label for="LowWalking" class="checkbox-label">Low-walking</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="SeniorFriendly"
              class="checkbox-input"
              formControlName="SeniorFriendly"
            />
            <label for="SeniorFriendly" class="checkbox-label"
              >Senior friendly</label
            >
          </div>
        </div>
      </div>

      <!-- Food preference -->
      <div>
        <div class="input-container">
          <label class="label">Food preference</label>
        </div>
        <div class="select-input-container" formGroupName="foodPreference">
          <div>
            <input
              type="checkbox"
              id="VegOnly"
              class="checkbox-input"
              formControlName="VegOnly"
            />
            <label for="VegOnly" class="checkbox-label">Veg Only</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="VegNonVeg"
              class="checkbox-input"
              formControlName="VegNonVeg"
            />
            <label for="VegNonVeg" class="checkbox-label">Veg+NonVeg</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="Vegan"
              class="checkbox-input"
              formControlName="Vegan"
            />
            <label for="Vegan" class="checkbox-label">Vegan</label>
          </div>
        </div>
      </div>

      <!-- Climate / Comfort preference -->
      <div>
        <div class="input-container">
          <label class="label">Comfort preference</label>
        </div>
        <div class="select-input-container" formGroupName="comfortPreference">
          <div>
            <input
              type="checkbox"
              id="AvoidHeat"
              class="checkbox-input"
              formControlName="AvoidHeat"
            />
            <label for="AvoidHeat" class="checkbox-label">Avoid heat</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="Comfortable"
              class="checkbox-input"
              formControlName="Comfortable"
            />
            <label for="Comfortable" class="checkbox-label">Comfortable</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="Any"
              class="checkbox-input"
              formControlName="Any"
            />
            <label for="Any" class="checkbox-label">Any</label>
          </div>
        </div>
      </div>

      <div class="button-container d-flex justify-content-center mt-3">
        <ion-button class="filled-blue-btn submit-btn" type="submit">
          Continue
        </ion-button>
      </div>
    </form>
  </div>
</div>
